export const MuiIconTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                width: dt.icon.size.medium,
                height: dt.icon.size.medium,
                color: dt.color.onSurface.key,
            },
            fontSizeSmall: {
                width: dt.icon.size.small,
                height: dt.icon.size.small,
            },
            fontSizeLarge: {
                width: dt.icon.size.large,
                height: dt.icon.size.large,
            },
            colorPrimary: {
                color: dt.color.primary.key,
            },
            colorSecondary: {
                color: dt.color.secondary.key,
            },
            colorSuccess: {
                color: dt.color.signal.success.key,
            },
            colorError: {
                color: dt.color.signal.error.key,
            },
            colorWarning: {
                color: dt.color.signal.warning.key,
            },
            colorInfo: {
                color: dt.color.signal.info.key,
            },
        },
    };
};
